import { queryKeys } from '../../queries/queryKeys';
import { post } from '../../queries';
import { useApiMutation } from '../../queries/useApiMutation';

export const useResetPasswordMutation = () => {
    const mutation = useApiMutation<{ userId: string; newPassword: string }>({
        invalidateQueryOnMutate: true,
        queryKey: queryKeys.auth(),
        mutationFn: ({ userId, newPassword }) =>
            post(`identity/resetPassword`, { userId: userId, password: newPassword }),
    });

    return { ...mutation };
};
